import React, { useContext } from 'react'
import { TenantSettingsContext } from '../../../../App'
import LogsComponent from '../../../../components/Logs/LogsComponent'

// The shell renders the page title, LogsComponent fetches the logs itself.
const ActivityLog = () => {
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig

  return (
    <LogsComponent
      hideTitle
      targetType="companySettings"
      targetId={orgSettings?._id}
    />
  )
}

export default ActivityLog
